/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebInputLoginModel
 */
export interface FrontWebInputLoginModel {
    /**
     * username
     * @type {string}
     * @memberof FrontWebInputLoginModel
     */
    username: string;
    /**
     * password
     * @type {string}
     * @memberof FrontWebInputLoginModel
     */
    password: string;
}

/**
 * Check if a given object implements the FrontWebInputLoginModel interface.
 */
export function instanceOfFrontWebInputLoginModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function FrontWebInputLoginModelFromJSON(json: any): FrontWebInputLoginModel {
    return FrontWebInputLoginModelFromJSONTyped(json, false);
}

export function FrontWebInputLoginModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebInputLoginModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function FrontWebInputLoginModelToJSON(value?: FrontWebInputLoginModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

